import createStore from "squawk-react";

import type { SignedAgreementResponse, Territory, Vendor } from "Src/api/Dto";

export const {
  action: actionApp,
  useSquawk: useSquawkApp,
  pending: pendingApp,
  usePending: usePendingApp
} = createStore<{ signedVendors: Vendor[]; allVendors: Vendor[]; territories: Territory[]; signedAgreements: SignedAgreementResponse[] }>(
  {
    signedVendors: [],
    allVendors: [],
    territories: [],
    signedAgreements: []
  },
  true
);
